"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLockedWidget = exports.canLink = exports.getFieldPath = void 0;
// extract field path form a field id
const getFieldPath = (formId = 'root', fieldId) => {
    // !!! IMPORTANT: no way (yet) to get the data path from here
    // so we rely on the field id which follows the pattern ${formId}_path_to_field
    // however if the form has keys that have "_", there is no way to retrieve the real concrete path...
    // so this won't work for forms data that exist below the root
    if (formId === fieldId)
        return ''; // this is the form root
    return fieldId.substr(formId.length + 1); // remove "${formId}_"
};
exports.getFieldPath = getFieldPath;
// so far disable linking if the field id has '_', ie either 'deep' path or root path with a '_' inside the key
// that's the safest we can do given the context provided by react-jsonschema-form so far...
const canLink = (path) => !path.includes('_');
exports.canLink = canLink;
// check if a field widget should be locked
// ie disabled because linked
const isLockedWidget = (id, links) => {
    if (!links)
        return false;
    const { id: formId, isMainForm, lockedPaths = [], linkedPaths = [] } = links;
    const fieldPath = exports.getFieldPath(formId, id);
    return (!isMainForm &&
        (lockedPaths.includes(fieldPath) || linkedPaths.includes(fieldPath)));
};
exports.isLockedWidget = isLockedWidget;
//# sourceMappingURL=links.js.map